import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { parseDate } from "@lyfegen-platform/utils";
import { Box, Typography, useTheme } from "@material-ui/core";
import { addDays } from "date-fns";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import useStyles from "../containers/data/forms/forms-styles";
import { localeDate } from "../utils/locale-date";
import { GeneralPatientIdFieldController } from "./general-patient-id-field-controller";

const coveragePeriodLengthDays = 365;

function CoverageEndDate() {
	const { palette } = useTheme();
	const styles = useStyles();
	const { t } = useTranslation();
	const [primaryInterventionDate] = useFieldValue(AttributeIdentifiers.PrimaryInterventionDate);
	const coveragePeriodEnd = primaryInterventionDate && addDays(parseDate(primaryInterventionDate), coveragePeriodLengthDays);

	return (
		<Box className={styles.colMedium} pl={1.5} pr={5}>
			<Typography variant="caption" style={{ color: palette.enabledHeader.main }}>
				{t("programCoverEndDate")}
			</Typography>
			<Typography style={{ color: palette.text.disabled }}>{!!coveragePeriodEnd && localeDate(coveragePeriodEnd)}</Typography>
		</Box>
	);
}

export class PrimaryInterventionDateRelatedPatientIdFieldController extends GeneralPatientIdFieldController {
	renderAfter(): React.ReactElement {
		return <CoverageEndDate />;
	}
}
